import { Star, StarOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { theme } from '@/styles/theme';

export default function FeaturedToggle({ isFeatured, onToggle, className = '' }) {
  return (
    <div className="relative">
      {/* 精选状态角标 */}
      {isFeatured && (
        <div className={`
          absolute -top-1 -right-1 z-10
          w-0 h-0 
          border-t-[24px] border-t-green-500 
          border-l-[24px] border-l-transparent
        `} />
      )}
      
      {/* 切换按钮 */}
      <Button
        variant="ghost"
        size="icon"
        className={`
          bg-black/50 hover:bg-black/70 
          w-8 h-8 rounded-lg
          ${className}
        `}
        onClick={onToggle}
      >
        {isFeatured ? (
          <Star className={`w-4 h-4 text-green-500 fill-green-500`} />
        ) : (
          <StarOff className="w-4 h-4 text-gray-400" />
        )}
      </Button>
    </div>
  );
} 